<template>
  <v-app>
    <v-main>
      <v-container>
        <h1 class="text-center">Medium Articles</h1>
        <v-form class="mt-5" @submit.prevent="submit()">
          <v-text-field label="Medium username" outlined class="mr-5" v-model="username"></v-text-field>
          <v-btn color="primary" large type="submit">Submit</v-btn>
        </v-form>
        <v-row>
          <v-col cols="12" md="12">
            <pre>{{ articles }}</pre>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getMediumPosts } from 'medium-articles';

export default {
  name: 'App',
  components: {},
  data: () => ({
    articles: [],
    username: '',
  }),
  methods: {
    async submit() {
      try {
        const response = await getMediumPosts(this.username);
        this.articles = response.posts;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.v-form {
  display: flex;
  justify-content: space-between;
}

pre {
  white-space: break-spaces;
}
</style>
